// AI Editor message status constants
export const MESSAGE_STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

export const MESSAGE_TYPES = {
  USER: 'user',
  AI: 'ai',
  SYSTEM: 'system'
} as const;

// Snackbar types
export const SNACKBAR_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

